import { useState } from "react";
import { CreateDepartmentModel } from "@core/model/query-model-department";
import { useQyCreateDepartment, useQyGetDepartment } from "@core/query/department.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownDepartment = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newDepartment, setNewDepartment] = useState<CreateDepartmentModel>({
    name: "",
    description: "",
  });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewDepartment({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newDepartment.name) {
      showWarning("Please fill in Department details");
      return;
    }
    setIsCreating(true);
    addDepartment(newDepartment);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New Department is added. Check and select the Department in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addDepartment } = useQyCreateDepartment(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: departmentResponse } = useQyGetDepartment('');
  const mappedDepartment = (departmentResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newDepartment,
    mappedDepartment,
    isCreating,
    departmentResponse,
    setSidebar,
    setFilter,
    setNewDepartment,
    handleFilterInput,
    handleAdd,
    addDepartment,
  };
};